<template>
  <div class="BaseProgressLinear progress-linear">
    <div
      class="progress-linear__progress"
      :style="progressStyles"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'BaseProgressLinear',
  props: {
    value: {
      type: [String, Number],
      default: 0,
    },
    transitionDuration: {
      type: String,
      default: '.3s',
    },
    animationTimingFunction: {
      type: String,
      default: 'ease-in-out',
    },
  },
  setup(props) {
    const calculatedValue = computed(() => {
      if (props.value > 100) return 100;
      return props.value ? Math.round(Number(props.value)) : 0;
    });
    const progressStyles = computed(() => ({
      width: `${calculatedValue.value}%`,
      transitionDuration: props.transitionDuration,
      animationTimingFunction: props.animationTimingFunction,
      willChange: 'width',
    }));

    return {
      progressStyles,
    };
  },
});
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.progress-linear
  width: 100%
  height: 3px
  background-color: $support_lightgray
  position: relative
  &__progress
    transition-property: width
    background-color: $secondary
    position: relative
    left: 0
    height: 100%
    width: 0%
    will-change: width
</style>
